import { Component, Input, OnInit } from "@angular/core";
import { CommunicationService } from "../../services/communication.service";
import { CommunicationContent } from "../../models/communications.model";

@Component({
    selector: 'app-communication-modal',
    templateUrl: './communication-modal.component.html',
    styleUrls: ['./communication-modal.component.scss'],
    standalone: false
})
export class CommunicationSrsModalComponent implements OnInit {

  @Input() onCloseCommunicationModal!: () => void;

  isFullScreen = false;
  communicationContent: CommunicationContent = CommunicationContent.MAIN_REQUESTS;

  protected readonly CommunicationContent = CommunicationContent;

  constructor(private communicationSrsService: CommunicationService) {}

  ngOnInit(): void {
    this.communicationSrsService.communicationContent$.subscribe(value => {
      this.communicationContent = value;
    });
  }

  toggleFullScreen(): void {
    this.isFullScreen = !this.isFullScreen;
    if (this.communicationContent == CommunicationContent.REQUEST_CHAT) {
      this.communicationContent = CommunicationContent.MAIN_REQUESTS;
    }
  }
}